
import { Carousel } from 'antd';

import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

import { getAccountUsernameFromPath, RootState } from '@share/utils';
import { useDispatch, useSelector } from 'react-redux';
import { getAshevillePlayDeals } from '@store/slices';
import { useIsVisible } from '@components';
import { Routes } from '@share/constants';

import './style.scss';

const SPEED = 1000;
const AUTOPLAY_SPEED = 4000;
const SLIDES_TO_SHOW = 1;
const SLIDES_TO_SCROLL = 1;

const propsCarousel = {
  dots: true,
  infinite: true,
  arrows: false,
  speed: SPEED,
  slidesToShow: SLIDES_TO_SHOW,
  slidesToScroll: SLIDES_TO_SCROLL,
  autoplay: true,
  autoplaySpeed: AUTOPLAY_SPEED,
  initialSlide: 2,
};

interface IProps {
  reference: React.RefObject<HTMLDivElement>;
}

export function SearchAshevillePlayBestDeals({ reference }: IProps) {
  const [elementRef, isVisible] = useIsVisible<HTMLDivElement>();

  const loginStore = useSelector((state: RootState) => state.loginStore);
  const ashevillePlayStore = useSelector((state: RootState) => state.ashevillePlayStore);

  const { loadings, errors, deals } = ashevillePlayStore;

  const account = loginStore?.account;

  const bestDeals = account?.ashevillePlayBestDeals || [];

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (bestDeals && bestDeals.length) {
      dispatch(getAshevillePlayDeals());
    }
  }, [bestDeals]);

  if (!deals || !deals.some((deal: any) => !!deal) || loadings.some((loading: boolean) => loading) || errors.some((error: string | null) => !!error)) {
    return null;
  }

  const handleDetail = (e: any, id: number, name: string) => {
    e.preventDefault();
    const accountName = getAccountUsernameFromPath(history);
    name = name.replace(/\s+/g, '-').toLowerCase().replace(/\.|\,/g, '');
    const path = `/${accountName}${Routes.Hotel}/${id}/${name}`;
    window.open(path, '_blank');
  }

  return (
    <div ref={elementRef} className="search-asheville-play-best-deals">
      <div className="main_title_2" ref={reference}>
        <h2>Asheville's Most Exciting Tours - All in One Place</h2>
        <p>Get 20% off from our top-rated Jeep rides and party trucks when you book a hotel.</p>
      </div>

      <div className={`best-deals-carousel-container ${isVisible ? 'animated-best-deals' : ''}`}>
        <Carousel {...propsCarousel}>
          {deals?.filter((hotel: any) => !!hotel).map((hotel: any, index: number) => (
            <div key={index} className="best-deals-carousel-item" onClick={e => handleDetail(e, hotel.propertyId, hotel.name)}>
              <div className="best-deals-carousel-item__container">
                <img src={hotel.thumb} alt={hotel.name} />
                
                {hotel.details?.descriptions?.headline &&
                  <div className="best-deals-carousel-item__head-line">
                    {hotel.details?.descriptions?.headline} 
                  </div>}

                <div className="best-deals-carousel-item__content">
                  <h3>{hotel.name}</h3>
                  <p>{hotel.details?.descriptions?.location || hotel.details?.descriptions?.amenities || ''}</p>

                  {hotel.price &&
                    <span><strong>${hotel.price}</strong> <label>Avg Nightly Price</label></span>}
                </div>

                <div className="best-deals-carousel-item__footer">
                  <div className="best-deals-carousel-item__footer-address">
                    <FontAwesomeIcon icon={faMapMarkerAlt} style={{ marginRight: '5px' }} />{hotel.address}, {hotel.cityName}, {hotel.stateName}
                  </div>
                  <div className="best-deals-carousel-item__footer-reviews">
                    <span>
                      <label>{hotel.reviewsCount}+</label>
                      <label>Google Reviews</label>
                    </span>
                    <div className={`rating ${hotel.starRating >= 4.5 ? 'good' : hotel.starRating >= 4 ? 'average' : 'bad'}`}>{hotel.starRating}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
}


